import React, { useState } from "react";
import T from "prop-types";
import { Map } from "immutable";

import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ConfirmAction from "MODULES/shared/components/ConfirmAction/ConfirmAction";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { APPROVED, CORE_REPAIR_HOLD } from "MODULES/RepairOrders/constants";
import {
  BUYER_ID,
  CAN_RELEASE_CORE_RETURN,
  QUALITY_CONTROL,
  REPAIR,
  ROLES
} from "MODULES/users/constants";
import { disableIfHasAnyOfRoles, hasPermission } from "MODULES/users/helpers";
import { without } from "lodash";
import { LINE_ITEMS } from "APP_ROOT/constants";
import { INVENTORY } from "MODULES/inventories/constants";

function ConfirmApproval({ repairOrder, onConfirm, currentUser }) {
  const [confirmationIsVisible, setConfirmationVisibility] = useState(false);

  if (repairOrder.get(APPROVED)) {
    return false;
  }

  if (repairOrder.get(CORE_REPAIR_HOLD)) {
    if (
      !hasPermission(currentUser, CAN_RELEASE_CORE_RETURN) &&
      repairOrder.getIn([LINE_ITEMS, 0, INVENTORY, BUYER_ID]) !== currentUser.id
    ) {
      return false;
    }
  } else if (
    disableIfHasAnyOfRoles(currentUser, without(ROLES, QUALITY_CONTROL, REPAIR))
  ) {
    return false;
  }

  return (
    <DropDownItem onClick={() => setConfirmationVisibility(true)}>
      <Icon name="check" fixed />
      &nbsp;Approve RO
      <ConfirmAction
        onConfirm={onConfirm}
        close={() => setConfirmationVisibility(false)}
        open={confirmationIsVisible}
        btnClass="btn-success"
        btnText="Yes, Approve Repair Order"
        cancelText="Cancel"
        icon={<i className="fa fa-fw fa-check" />}
      >
        <strong>Heads up!</strong>
        &nbsp; Are you sure you want to approve this Repair Order?
      </ConfirmAction>
    </DropDownItem>
  );
}

export default withCurrentUser(ConfirmApproval);

ConfirmApproval.propTypes = {
  repairOrder: T.instanceOf(Map).isRequired,
  onConfirm: T.func.isRequired,
  currentUser: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/ConfirmApproval/ConfirmApproval.jsx